window.addEventListener('DOMContentLoaded', function () {
	try {
		makeTableClasses();
	} catch(err) {
		console.log(err)
	}
	
})

function makeTableClasses() {
	let deliveryTable = document.querySelector('.delivery-pay__table table');
	if (!deliveryTable) {
		return false;
	}
	let lines =	deliveryTable.querySelectorAll('td.line');
	lines.forEach((line, idx)=> {
		let originContent = line.innerHTML;
		let newWrapper = document.createElement('div');
		newWrapper.classList.add('flex-body');
		newWrapper.insertAdjacentHTML('beforeend', originContent);
		line.innerHTML = '';
		line.insertAdjacentElement('beforeend', newWrapper);
	})
}
